import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../config/firebase';

export async function getFatigueStatus(driverId) {
  const snap = await getDoc(doc(db, 'driverFatigue', driverId));
  return snap.exists() ? snap.data() : { dailyHours: 0, weeklyHours: 0, consecutiveDays: 0, nightHours: 0, lockedOut: false };
}

export function subscribeToFatigueStatus(driverId, callback) {
  return onSnapshot(doc(db, 'driverFatigue', driverId), (snap) => {
    callback(snap.exists() ? snap.data() : null);
  });
}

export async function submitPreTripChecklist(driverId, responses) {
  const fn = httpsCallable(functions, 'submitPreTripChecklist');
  return (await fn({ driverId, responses })).data;
}

export async function getPreTripChecklists(driverId, maxResults = 20) {
  const { collection: col, query: q, where, orderBy, getDocs, limit } = await import('firebase/firestore');
  const ref = q(col(db, 'preTrip'), where('driverId', '==', driverId), orderBy('completedAt', 'desc'), limit(maxResults));
  const snap = await getDocs(ref);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
